import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PinGate } from '../../components/technician/PinGate';
import { TechnicianConsole } from '../../components/technician/TechnicianConsole';
import { ToastStack } from '../../components/technician/ToastStack';
import { AUTO_LOCK_MESSAGE, IDLE_CHECK_MS } from '../../lib/technician/catalog';
import { ROUTE } from '../../lib/rcu/catalog/navigation';
import { useTechnicianStore } from '../../stores/technicianStore';
import { useToastStore } from '../../stores/toastStore';

/**
 * The hidden technician console: PIN gate, then the configuration surface.
 * Reached by five quick taps on the Toyama logo in Settings.
 */
export const TechnicianPage: React.FC = () => {
  const navigate = useNavigate();
  const isUnlocked = useTechnicianStore((state) => state.isUnlocked);
  const lock = useTechnicianStore((state) => state.lock);
  const lockIfIdle = useTechnicianStore((state) => state.lockIfIdle);
  const noteActivity = useTechnicianStore((state) => state.noteActivity);
  const info = useToastStore((state) => state.info);

  // Any interaction restarts the idle timer; a background check locks the console.
  React.useEffect(() => {
    const markActivity = (): void => noteActivity(Date.now());
    const events = ['pointerdown', 'keydown', 'wheel'] as const;
    events.forEach((event) => document.addEventListener(event, markActivity));

    const timer = setInterval(() => {
      if (lockIfIdle(Date.now())) info(AUTO_LOCK_MESSAGE);
    }, IDLE_CHECK_MS);

    return () => {
      events.forEach((event) => document.removeEventListener(event, markActivity));
      clearInterval(timer);
    };
  }, [lockIfIdle, noteActivity, info]);

  /**
   * The broker session outlives this page: it belongs to the app, because the
   * guest room controls read the RCU's state from it (`components/LinkHost`).
   * Locking hides the console, it does not stop the link.
   */

  const exit = (): void => {
    lock();
    navigate(ROUTE.CONTROLS);
  };

  return (
    <>
      {isUnlocked ? <TechnicianConsole onExit={exit} /> : <PinGate />}
      <ToastStack />
    </>
  );
};

export default TechnicianPage;
